import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';
import {graniteGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  item: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    display: 'flex',
    width: '100%',
    paddingHorizontal: indent * 0.75,
  },
  itemRecent: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    width: '100%',
    paddingHorizontal: indent * 1.25,
  },
  base: {
    display: 'flex',
    flexDirection: 'row',
  },
  textWrapper: {
    paddingLeft: indent * 0.8,
    flex: 1,
  },
  arrowIcon: {
    color: graniteGray,
    fontSize: 24,
    alignSelf: 'center',
  },
});
